<template>
	<div v-loading.fullscreen.lock="loading">
		<!-- swiper 插件 轮播图 -->
		<div class="banner">
			<img :src="banner" alt="">
			<div class="title" v-if="pageData.type === 2">行业资讯</div>
			<div class="title" v-if="pageData.type === 1">企业动态</div>
		</div>

		<!-- 内容容器 -->
		<div class="content-wrapper">
			<section class="data-details" v-if="pageData && pageData.isShow">
				<div class="content">
          <div class="title">{{pageData.title}}</div>
          <div class="date">{{pageData.createTime}} <span>{{pageData.sourceName}}</span></div>
          <div v-html="pageData.content"></div>
				</div>
			</section>
      <section v-else>
        <div class="tip">该文章不存在</div>
      </section>

      <section class="footer-box">
        <div class="content">
          <div class="btn left" v-if="caseIndex > 0">
            <i class="el-icon-arrow-left"></i>
            <div class="text" @click="openPage(`/new/details/${caseLists[caseIndex-1].id}`)" >上一篇 {{caseLists[caseIndex-1].title}}</div>
          </div>
          <div  class="btn right" v-if="caseIndex < caseLists.length-2">
            <div class="text" @click="openPage(`/new/details/${caseLists[caseIndex+1].id}`)" >下一篇 {{caseLists[caseIndex+1].title}}</div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </section>
		</div>
	</div>
</template>

<script>
  import Swiper from 'swiper';
	import { caseDetail, casePage, companyItemList, bannerList, indexDataList, getAppInfo, itemList } from '@/utils/api';
  
  export default {
		name: 'NewDetails',
		props: {},
		components: {},
		data() {
			return {
				screenWidth: 0,
				screenHeight: 0,
				activeNav: 'new',
				pageData: {},
				data2Index: 0,
				serviceIndex: 0,
        params: { type: '' },
        caseLists: [],
        caseIndex: 0,
        loading: true,
        banner: ''
			};
		},
		components: {},
		created() {
			this.$store.commit('activeNav', 'new');
      this.init();
    },
    watch: {
      $route(to, from) {
				console.log('watch--$route--from==', from.path);//从哪来
				console.log('watch--$route--to==', to.path);//到哪去
				this.init();
			}
    },
		computed: {
		},
		mounted() {},
		methods: {
      async init() {
        this.loading = true;
        const params = this.$route.params;
        this.params = Object.assign(this.params, params)
        
        console.log('newDetails--params === ', this.params);
        
        await this.casePage();
        const res1 = await caseDetail(this.params.id);
        this.pageData = res1.data.baseData;
        if (this.pageData.type === 1) {
          const res = await getAppInfo('key-info-case-bg-imgUrl1');
          this.banner = res.data.baseData.content;
        } else if (this.pageData.type === 2) {
          const res = await getAppInfo('key-info-case-bg-imgUrl2');
          this.banner = res.data.baseData.content;
        }
        
        this.caseIndex = this.caseLists.findIndex(d => d.id == this.params.id && d.isShow)
        console.log('newDetails--caseDetail--this.caseIndex==', this.caseIndex);
        console.log('newDetails--caseDetail--res1==', res1);

        this.$set(this, 'pageData', this.pageData);
        console.log('newDetails--this.pageData==', this.pageData);
        this.loading = false;
      },
      async casePage(page) {
				const payload = {
          type: this.pageData.type,
					page: page || 1
				};
				const res = await casePage(payload);
        console.log('newDetails--casePage--res==', res);
        this.caseLists = res.data.baseData.list || [];
				// return res.data.baseData;
      },
      openPage(url) {
        console.log('openPage--url==', url);
        
        let cur_route = this.$route.path
        if (cur_route == url) {
          return;
        }
        this.$router.push(url);
      },

			changeNav(item) {
				console.log('changeNav--item==', item);
				if (item.id === 'product') {
					// this.showProductMenu = !this.showProductMenu;
					this.showProductMenu = true;
				} else {
					this.showProductMenu = false;
				}
				this.activeNav = item.id;
				// this.$router.push({path: '/pages/product'})
			},
			changeServiceIndex(index) {
				this.serviceIndex = index;
			},
			handleOpen(e) {
				console.log('handleOpen--e==', e);
			},
			handleClose(e) {
				console.log('handleClose--e==', e);
			},
			handleSliceStr(str, start = 0, end) {
				var str1 = JSON.parse(JSON.stringify(str));
				if (!str) {
					return '';
				}
				if (!end || end > str.length) {
					end = str.length;
				}
				return str1.slice(start, end);
			},
			// changeData2Index(num) {
			//   const max = Math.ceil(this.pageData.data2.lists.length / 4);
			//   console.log('changeData2Index--max==', max);

			//   if (num > 0 && this.data2Index < max) {
			//     this.data2Index += num;
			//   } else if (num < 0 && this.data2Index > 0) {
			//     this.data2Index += num;
			//   }
			// }
		}
	}
</script>

<style scoped lang="scss">
@import '../common/css/newDetails.scss';
</style>



// WEBPACK FOOTER //
// src/pages/NewDetails.vue